import Enumerable from "linq";
import { HttpMethod, UploadCommand } from "~/extensions/api";
export class UpdateAdminInformationCommand extends UploadCommand {
    constructor(model) {
        super(HttpMethod.Post, "information/admin/update");
        this.informationNo = model.informationNo ?? -1;
        this.startAt = model.startAt;
        this.endAt = model.endAt;
        this.weight = model.weight;
        this.isMailNotification = model.isEmailNotification;
        this.emailNotificationDate = model.emailNotificationDate;
        this.emailNotificationHour = model.emailNotificationHour;
        this.emailNotificationMinute = model.emailNotificationMinute;
        this.subject = model.subject;
        this.main = model.main;
        this.importFiles = model.newFiles;
        this.responseDeadline = model.responseDeadline;
        this.affirmativeText = model.affirmativeText;
        this.negativeText = model.negativeText;
        this.negativeNotificationDepartment = model.negativeNotificationDepartment;
        this.existingFiles = Enumerable.from(model.existingFiles)
            .select(x => new ExistingFileParameter(x))
            .toArray();
    }
    informationNo = -1;
    startAt = "";
    endAt = "";
    weight = false;
    isMailNotification = false;
    emailNotificationDate = "";
    emailNotificationHour = null;
    emailNotificationMinute = null;
    subject = "";
    main = "";
    importFiles = [];
    responseDeadline = "";
    affirmativeText = "";
    negativeText = "";
    negativeNotificationDepartment = [];
    existingFiles = [];
}
class ExistingFileParameter {
    constructor(model) {
        this.fileId = model.fileId;
        this.fileName = model.fileName;
        this.isDelete = model.isDelete;
    }
    fileId;
    fileName;
    isDelete;
}
